module.exports = __webpack_public_path__ + "img/group3.df74dd73.svg";